namespace appn.views.taskTemplates.settings {

    export function init(): void {
        addEvents();

        if ($('nav .navbar-nav-right button[value*="Trash"]').length > 0)
            appn.trash.addTrashMessage($('nav .navbar-nav-right button[value*="Trash"]'), '#Template_Name', undefined, undefined, false);
    }

    function addEvents() {

        $('.addMetaItem').on('click', function(event) {
            event.preventDefault();

            if ($('#metaData tbody').children().length === 0) {
                $('#metaData').show();
                $('.addMetaItem').css('top', '0px');
            }

            const items = $('#metaData tbody');
            const idx = items.children().length;
            const newRow = `<tr><td class="dataCol name">` +
                `<input class="metaDataVal form-control form-control-sm" type="text" name="Template.Statuses[${idx}].Value" class="valid">` +
                `</td><td class="dataCol name">` +
                `<input class="metaDataDis form-control form-control-sm" type="text" name="Template.Statuses[${idx}].Display" class="valid">` +
                `</td><td class="dataCol name">` +
                `<input class="metaDataCol colorPicker form-control form-control-sm" type="text" name="Template.Statuses[${idx}].Color" class="valid" id="color_${idx}">` +
                `</td></tr>`;

            $('#metaData tbody').append(newRow);
            ($(`#color_${idx}`) as any).minicolors();
            addDeleteRowEvent();
        });

        addDeleteRowEvent();

        appn.minicolors.init();
        appn.select.init({
            selector: 'select#iconsToDisplay',
            isIconSelect: true
        });
    }

    function addDeleteRowEvent() {
        $('#metaData .delete_button').off().on('click', function() {
            const tableName = $(this)?.attr('data-tablename') ?? appn.emptyString;
            $(this).parents('tr').remove();

            renameRows(tableName);

            if ($('#metaData tbody').children().length === 0) {
                $('#metaData').hide();
                $('.addMetaItem').css('top', '-20px');
            }
        });
    }

    function renameRows(tableName: string) {
        if (tableName === 'metaData')
            renameMetaData();
    }

    function renameMetaData() {
        // rename all remaining rows to keep continuous index
        let idx = 0;
        $('#metaData tbody tr').each(function(index, row) {

            $(this).find('.metaDataVal')
                .attr('name', `Template.Statuses[${idx}].Value`);

            $(this).find('.metaDataDis')
                .attr('name', `Template.Statuses[${idx}].Display`);

            $(this).find('.metaDataCol')
                .attr('name', `Template.Statuses[${idx}].Color`);

            idx++;
        });
    }

}
